/**
 * Generated by scripts/auth-route-parity.mjs. Do not edit.
 * Wave 0 Auth Finality operation catalog (live rust + embedded scan).
 */
import type { AthenaAuthOperationDefinition } from "./operations.ts";

export const ATHENA_AUTH_OPERATIONS: AthenaAuthOperationDefinition[] = [
  {
    "auth": "session",
    "capability": "sessions",
    "embedded": "supported",
    "id": "authorization.roles.by",
    "method": "DELETE",
    "mutation": true,
    "path": "/authorization/roles/{id}",
    "rust": "unsupported"
  },
  {
    "auth": "public",
    "capability": "jwt",
    "embedded": "supported",
    "id": "jwt.jwks",
    "method": "GET",
    "mutation": false,
    "path": "/.well-known/jwks.json",
    "rust": "supported"
  },
  {
    "auth": "protocol",
    "capability": "oauthAuthorizationServer",
    "embedded": "supported",
    "id": "oauth.metadata",
    "method": "GET",
    "mutation": false,
    "path": "/.well-known/oauth-authorization-server",
    "rust": "unsupported"
  },
  {
    "auth": "public",
    "capability": "jwt",
    "embedded": "supported",
    "id": "jwt.discovery",
    "method": "GET",
    "mutation": false,
    "path": "/.well-known/openid-configuration",
    "rust": "supported"
  },
  {
    "auth": "public",
    "capability": "passkeys",
    "embedded": "supported",
    "id": "passkey.relatedOrigins",
    "method": "GET",
    "mutation": false,
    "path": "/.well-known/webauthn",
    "rust": "supported"
  },
  {
    "auth": "admin",
    "capability": "email",
    "embedded": "supported",
    "id": "admin.emailEventType.list",
    "method": "GET",
    "mutation": false,
    "path": "/admin/email-event-type/list",
    "rust": "supported"
  },
  {
    "auth": "admin",
    "capability": "email",
    "embedded": "supported",
    "id": "admin.emailFailure.get",
    "method": "GET",
    "mutation": false,
    "path": "/admin/email-failure/get",
    "rust": "supported"
  },
  {
    "auth": "admin",
    "capability": "email",
    "embedded": "supported",
    "id": "admin.emailFailure.list",
    "method": "GET",
    "mutation": false,
    "path": "/admin/email-failure/list",
    "rust": "supported"
  },
  {
    "auth": "admin",
    "capability": "email",
    "embedded": "supported",
    "id": "admin.emailTemplate.get",
    "method": "GET",
    "mutation": false,
    "path": "/admin/email-template/get",
    "rust": "supported"
  },
  {
    "auth": "admin",
    "capability": "email",
    "embedded": "supported",
    "id": "admin.emailTemplate.list",
    "method": "GET",
    "mutation": false,
    "path": "/admin/email-template/list",
    "rust": "supported"
  },
  {
    "auth": "admin",
    "capability": "email",
    "embedded": "supported",
    "id": "admin.email.get",
    "method": "GET",
    "mutation": false,
    "path": "/admin/email/get",
    "rust": "supported"
  },
  {
    "auth": "admin",
    "capability": "email",
    "embedded": "supported",
    "id": "admin.email.list",
    "method": "GET",
    "mutation": false,
    "path": "/admin/email/list",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "apiKeys",
    "embedded": "supported",
    "id": "apiKey.get",
    "method": "GET",
    "mutation": false,
    "path": "/api-key/get",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "apiKeys",
    "embedded": "supported",
    "id": "apiKey.list",
    "method": "GET",
    "mutation": false,
    "path": "/api-key/list",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "embedded": "supported",
    "id": "authorization.assignments.members.list",
    "method": "GET",
    "mutation": false,
    "path": "/authorization/assignments/members",
    "rust": "unsupported"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "embedded": "supported",
    "id": "authorization.assignments.users.list",
    "method": "GET",
    "mutation": false,
    "path": "/authorization/assignments/users",
    "rust": "unsupported"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "embedded": "supported",
    "id": "authorization.audit",
    "method": "GET",
    "mutation": false,
    "path": "/authorization/audit",
    "rust": "unsupported"
  },
  {
    "auth": "session",
    "capability": "oauthAuthorizationServer",
    "embedded": "supported",
    "id": "oauth.grant.list",
    "method": "GET",
    "mutation": false,
    "path": "/authorization/grants",
    "rust": "unsupported"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "embedded": "supported",
    "id": "authorization.rights",
    "method": "GET",
    "mutation": false,
    "path": "/authorization/rights",
    "rust": "unsupported"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "embedded": "supported",
    "id": "authorization.roles",
    "method": "GET",
    "mutation": false,
    "path": "/authorization/roles",
    "rust": "unsupported"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "embedded": "supported",
    "id": "authorization.roles.by",
    "method": "GET",
    "mutation": false,
    "path": "/authorization/roles/{id}",
    "rust": "unsupported"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "embedded": "supported",
    "id": "authorization.snapshot",
    "method": "GET",
    "mutation": false,
    "path": "/authorization/snapshot",
    "rust": "unsupported"
  },
  {
    "auth": "public",
    "capability": "social",
    "embedded": "supported",
    "id": "social.callback",
    "method": "GET",
    "mutation": false,
    "path": "/callback/{provider}",
    "rust": "supported"
  },
  {
    "auth": "public",
    "capability": "password",
    "embedded": "supported",
    "id": "user.email.verify.change",
    "method": "GET",
    "mutation": false,
    "path": "/change-email/verify",
    "rust": "supported"
  },
  {
    "auth": "public",
    "capability": "password",
    "embedded": "supported",
    "id": "user.delete.verify",
    "method": "GET",
    "mutation": false,
    "path": "/delete-user/verify",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "email",
    "embedded": "supported",
    "id": "email.list",
    "method": "GET",
    "mutation": false,
    "path": "/email/list",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "embedded": "supported",
    "id": "session.get",
    "method": "GET",
    "mutation": false,
    "path": "/get-session",
    "rust": "supported"
  },
  {
    "auth": "public",
    "capability": "health",
    "embedded": "supported",
    "id": "health.health",
    "method": "GET",
    "mutation": false,
    "path": "/health",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "accounts",
    "embedded": "supported",
    "id": "account.list",
    "method": "GET",
    "mutation": false,
    "path": "/list-accounts",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "embedded": "supported",
    "id": "session.list",
    "method": "GET",
    "mutation": false,
    "path": "/list-sessions",
    "rust": "supported"
  },
  {
    "auth": "protocol",
    "capability": "oauthAuthorizationServer",
    "embedded": "supported",
    "id": "oauth.authorization.request",
    "method": "GET",
    "mutation": false,
    "path": "/oauth/authorize",
    "rust": "unsupported"
  },
  {
    "auth": "public",
    "capability": "health",
    "embedded": "supported",
    "id": "health.ok",
    "method": "GET",
    "mutation": false,
    "path": "/ok",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "embedded": "supported",
    "id": "member.active",
    "method": "GET",
    "mutation": false,
    "path": "/organization/get-active-member",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "embedded": "supported",
    "id": "organization.get",
    "method": "GET",
    "mutation": false,
    "path": "/organization/get-full-organization",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "invitations",
    "embedded": "supported",
    "id": "invitation.get",
    "method": "GET",
    "mutation": false,
    "path": "/organization/get-invitation",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "embedded": "supported",
    "id": "organization.list",
    "method": "GET",
    "mutation": false,
    "path": "/organization/list",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "invitations",
    "embedded": "supported",
    "id": "invitation.list",
    "method": "GET",
    "mutation": false,
    "path": "/organization/list-invitations",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "embedded": "supported",
    "id": "member.list",
    "method": "GET",
    "mutation": false,
    "path": "/organization/list-members",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "invitations",
    "embedded": "supported",
    "id": "invitation.listUser",
    "method": "GET",
    "mutation": false,
    "path": "/organization/list-user-invitations",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "passkeys",
    "embedded": "supported",
    "id": "passkey.register.options",
    "method": "GET",
    "mutation": false,
    "path": "/passkey/generate-register-options",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "passkeys",
    "embedded": "supported",
    "id": "passkey.list",
    "method": "GET",
    "mutation": false,
    "path": "/passkey/list-user-passkeys",
    "rust": "supported"
  },
  {
    "auth": "public",
    "capability": "password",
    "embedded": "supported",
    "id": "user.password.reset.token",
    "method": "GET",
    "mutation": false,
    "path": "/reset-password/{token}",
    "rust": "supported"
  },
  {
    "auth": "public",
    "capability": "password",
    "embedded": "supported",
    "id": "user.email.verify",
    "method": "GET",
    "mutation": false,
    "path": "/verify-email",
    "rust": "supported",
    "domainEvent": "user.email.verify"
  },
  {
    "auth": "public",
    "capability": "health",
    "embedded": "supported",
    "id": "health.ok.head",
    "method": "HEAD",
    "mutation": false,
    "path": "/ok",
    "rust": "unsupported"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "embedded": "supported",
    "id": "authorization.roles.by",
    "method": "PATCH",
    "mutation": true,
    "path": "/authorization/roles/{id}",
    "rust": "unsupported"
  },
  {
    "auth": "admin",
    "capability": "email",
    "embedded": "supported",
    "id": "admin.emailFailure.create",
    "method": "POST",
    "mutation": true,
    "path": "/admin/email-failure/create",
    "rust": "supported"
  },
  {
    "auth": "admin",
    "capability": "email",
    "embedded": "supported",
    "id": "admin.emailFailure.delete",
    "method": "POST",
    "mutation": true,
    "path": "/admin/email-failure/delete",
    "rust": "supported"
  },
  {
    "auth": "admin",
    "capability": "email",
    "embedded": "supported",
    "id": "admin.emailFailure.update",
    "method": "POST",
    "mutation": true,
    "path": "/admin/email-failure/update",
    "rust": "supported"
  },
  {
    "auth": "admin",
    "capability": "email",
    "embedded": "supported",
    "id": "admin.emailTemplate.create",
    "method": "POST",
    "mutation": true,
    "path": "/admin/email-template/create",
    "rust": "supported"
  },
  {
    "auth": "admin",
    "capability": "email",
    "embedded": "supported",
    "id": "admin.emailTemplate.delete",
    "method": "POST",
    "mutation": true,
    "path": "/admin/email-template/delete",
    "rust": "supported"
  },
  {
    "auth": "admin",
    "capability": "email",
    "embedded": "supported",
    "id": "admin.emailTemplate.send",
    "method": "POST",
    "mutation": true,
    "path": "/admin/email-template/send",
    "rust": "supported"
  },
  {
    "auth": "admin",
    "capability": "email",
    "embedded": "supported",
    "id": "admin.emailTemplate.update",
    "method": "POST",
    "mutation": true,
    "path": "/admin/email-template/update",
    "rust": "supported"
  },
  {
    "auth": "admin",
    "capability": "email",
    "embedded": "supported",
    "id": "admin.email.create",
    "method": "POST",
    "mutation": true,
    "path": "/admin/email/create",
    "rust": "supported"
  },
  {
    "auth": "admin",
    "capability": "email",
    "embedded": "supported",
    "id": "admin.email.delete",
    "method": "POST",
    "mutation": true,
    "path": "/admin/email/delete",
    "rust": "supported"
  },
  {
    "auth": "admin",
    "capability": "email",
    "embedded": "supported",
    "id": "admin.email.update",
    "method": "POST",
    "mutation": true,
    "path": "/admin/email/update",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "apiKeys",
    "embedded": "supported",
    "id": "apiKey.create",
    "method": "POST",
    "mutation": true,
    "path": "/api-key/create",
    "rust": "supported",
    "domainEvent": "apiKey.create"
  },
  {
    "auth": "session",
    "capability": "apiKeys",
    "embedded": "supported",
    "id": "apiKey.delete",
    "method": "POST",
    "mutation": true,
    "path": "/api-key/delete",
    "rust": "supported",
    "domainEvent": "apiKey.delete"
  },
  {
    "auth": "session",
    "capability": "apiKeys",
    "embedded": "supported",
    "id": "apiKey.deleteExpired",
    "method": "POST",
    "mutation": true,
    "path": "/api-key/delete-all-expired-api-keys",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "apiKeys",
    "embedded": "supported",
    "id": "apiKey.get.post",
    "method": "POST",
    "mutation": false,
    "path": "/api-key/get",
    "rust": "unsupported"
  },
  {
    "auth": "session",
    "capability": "apiKeys",
    "embedded": "supported",
    "id": "apiKey.update",
    "method": "POST",
    "mutation": true,
    "path": "/api-key/update",
    "rust": "supported",
    "domainEvent": "apiKey.update"
  },
  {
    "auth": "session",
    "capability": "apiKeys",
    "embedded": "supported",
    "id": "apiKey.verify",
    "method": "POST",
    "mutation": false,
    "path": "/api-key/verify",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "embedded": "supported",
    "id": "authorization.roles",
    "method": "POST",
    "mutation": true,
    "path": "/authorization/roles",
    "rust": "unsupported"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "embedded": "supported",
    "id": "authorization.roles.clone",
    "method": "POST",
    "mutation": true,
    "path": "/authorization/roles/clone",
    "rust": "unsupported"
  },
  {
    "auth": "public",
    "capability": "social",
    "embedded": "supported",
    "id": "callback.by",
    "method": "POST",
    "mutation": true,
    "path": "/callback/{provider}",
    "rust": "unsupported"
  },
  {
    "auth": "session",
    "capability": "password",
    "embedded": "supported",
    "id": "user.email.update",
    "method": "POST",
    "mutation": true,
    "path": "/change-email",
    "rust": "supported",
    "domainEvent": "user.email.update"
  },
  {
    "auth": "public",
    "capability": "password",
    "embedded": "supported",
    "id": "user.email.verify.change.post",
    "method": "POST",
    "mutation": true,
    "path": "/change-email/verify",
    "rust": "unsupported"
  },
  {
    "auth": "session",
    "capability": "password",
    "embedded": "supported",
    "id": "user.password.change",
    "method": "POST",
    "mutation": true,
    "path": "/change-password",
    "rust": "supported",
    "domainEvent": "user.password.change"
  },
  {
    "auth": "session",
    "capability": "password",
    "embedded": "supported",
    "id": "user.delete",
    "method": "POST",
    "mutation": true,
    "path": "/delete-user",
    "rust": "supported",
    "domainEvent": "user.delete"
  },
  {
    "auth": "public",
    "capability": "password",
    "embedded": "supported",
    "id": "user.password.forget",
    "method": "POST",
    "mutation": true,
    "path": "/forget-password",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "jwt",
    "embedded": "supported",
    "id": "jwt.accessToken",
    "method": "POST",
    "mutation": true,
    "path": "/get-access-token",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "embedded": "supported",
    "id": "session.get.post",
    "method": "POST",
    "mutation": false,
    "path": "/get-session",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "social",
    "embedded": "supported",
    "id": "account.link",
    "method": "POST",
    "mutation": true,
    "path": "/link-social",
    "rust": "supported",
    "domainEvent": "account.link"
  },
  {
    "auth": "protocol",
    "capability": "oauthAuthorizationServer",
    "embedded": "supported",
    "id": "oauth.authorization.decision",
    "method": "POST",
    "mutation": true,
    "path": "/oauth/authorize",
    "rust": "unsupported"
  },
  {
    "auth": "protocol",
    "capability": "oauthAuthorizationServer",
    "embedded": "supported",
    "id": "oauth.token.revoke",
    "method": "POST",
    "mutation": true,
    "path": "/oauth/revoke",
    "rust": "unsupported"
  },
  {
    "auth": "protocol",
    "capability": "oauthAuthorizationServer",
    "embedded": "supported",
    "id": "oauth.token.exchange",
    "method": "POST",
    "mutation": true,
    "path": "/oauth/token",
    "rust": "unsupported"
  },
  {
    "auth": "session",
    "capability": "invitations",
    "embedded": "supported",
    "id": "invitation.accept",
    "method": "POST",
    "mutation": true,
    "path": "/organization/accept-invitation",
    "rust": "supported",
    "domainEvent": "organization.invitation.accept"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "embedded": "supported",
    "id": "member.add",
    "method": "POST",
    "mutation": true,
    "path": "/organization/add-member",
    "rust": "unsupported",
    "domainEvent": "organization.member.add"
  },
  {
    "auth": "session",
    "capability": "invitations",
    "embedded": "supported",
    "id": "invitation.cancel",
    "method": "POST",
    "mutation": true,
    "path": "/organization/cancel-invitation",
    "rust": "supported",
    "domainEvent": "organization.invitation.cancel"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "embedded": "supported",
    "id": "organization.checkSlug",
    "method": "POST",
    "mutation": false,
    "path": "/organization/check-slug",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "embedded": "supported",
    "id": "organization.create",
    "method": "POST",
    "mutation": true,
    "path": "/organization/create",
    "rust": "supported",
    "domainEvent": "organization.create"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "embedded": "supported",
    "id": "organization.delete",
    "method": "POST",
    "mutation": true,
    "path": "/organization/delete",
    "rust": "supported",
    "domainEvent": "organization.delete"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "embedded": "supported",
    "id": "organization.hasPermission",
    "method": "POST",
    "mutation": false,
    "path": "/organization/has-permission",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "invitations",
    "embedded": "supported",
    "id": "invitation.create",
    "method": "POST",
    "mutation": true,
    "path": "/organization/invite-member",
    "rust": "supported",
    "domainEvent": "organization.invitation.create"
  },
  {
    "auth": "session",
    "capability": "invitations",
    "embedded": "supported",
    "id": "invitation.reminder",
    "method": "POST",
    "mutation": true,
    "path": "/organization/invite-member-reminder",
    "rust": "unsupported",
    "domainEvent": "organization.member.invite.reminder"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "embedded": "supported",
    "id": "organization.leave",
    "method": "POST",
    "mutation": true,
    "path": "/organization/leave",
    "rust": "supported",
    "domainEvent": "organization.member.remove"
  },
  {
    "auth": "session",
    "capability": "invitations",
    "embedded": "supported",
    "id": "invitation.reject",
    "method": "POST",
    "mutation": true,
    "path": "/organization/reject-invitation",
    "rust": "supported",
    "domainEvent": "organization.invitation.reject"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "embedded": "supported",
    "id": "member.remove",
    "method": "POST",
    "mutation": true,
    "path": "/organization/remove-member",
    "rust": "supported",
    "domainEvent": "organization.member.remove"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "embedded": "supported",
    "id": "organization.setActive",
    "method": "POST",
    "mutation": true,
    "path": "/organization/set-active",
    "rust": "supported",
    "domainEvent": "session.activeOrganization.update"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "embedded": "supported",
    "id": "organization.update",
    "method": "POST",
    "mutation": true,
    "path": "/organization/update",
    "rust": "supported",
    "domainEvent": "organization.update"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "embedded": "supported",
    "id": "member.role.update",
    "method": "POST",
    "mutation": true,
    "path": "/organization/update-member-role",
    "rust": "supported",
    "domainEvent": "organization.member.role.update"
  },
  {
    "auth": "session",
    "capability": "passkeys",
    "embedded": "supported",
    "id": "passkey.delete",
    "method": "POST",
    "mutation": true,
    "path": "/passkey/delete-passkey",
    "rust": "supported",
    "domainEvent": "passkey.delete"
  },
  {
    "auth": "optional-session",
    "capability": "passkeys",
    "embedded": "supported",
    "id": "passkey.authenticate.options",
    "method": "POST",
    "mutation": true,
    "path": "/passkey/generate-authenticate-options",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "passkeys",
    "embedded": "supported",
    "id": "passkey.update",
    "method": "POST",
    "mutation": true,
    "path": "/passkey/update-passkey",
    "rust": "supported",
    "domainEvent": "passkey.update"
  },
  {
    "auth": "public",
    "capability": "passkeys",
    "embedded": "supported",
    "id": "passkey.authenticate.verify",
    "method": "POST",
    "mutation": true,
    "path": "/passkey/verify-authentication",
    "rust": "supported",
    "domainEvent": "session.issue"
  },
  {
    "auth": "session",
    "capability": "passkeys",
    "embedded": "supported",
    "id": "passkey.register.verify",
    "method": "POST",
    "mutation": true,
    "path": "/passkey/verify-registration",
    "rust": "supported",
    "domainEvent": "passkey.register"
  },
  {
    "auth": "session",
    "capability": "jwt",
    "embedded": "supported",
    "id": "jwt.refresh",
    "method": "POST",
    "mutation": true,
    "path": "/refresh-token",
    "rust": "supported"
  },
  {
    "auth": "public",
    "capability": "password",
    "embedded": "supported",
    "id": "user.password.reset",
    "method": "POST",
    "mutation": true,
    "path": "/reset-password",
    "rust": "supported",
    "domainEvent": "user.password.reset"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "embedded": "supported",
    "id": "session.revoke.others",
    "method": "POST",
    "mutation": true,
    "path": "/revoke-other-sessions",
    "rust": "supported",
    "domainEvent": "session.revoke"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "embedded": "supported",
    "id": "session.revoke",
    "method": "POST",
    "mutation": true,
    "path": "/revoke-session",
    "rust": "supported",
    "domainEvent": "session.revoke"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "embedded": "supported",
    "id": "session.revoke.all",
    "method": "POST",
    "mutation": true,
    "path": "/revoke-sessions",
    "rust": "supported",
    "domainEvent": "session.revoke"
  },
  {
    "auth": "session",
    "capability": "email",
    "embedded": "supported",
    "id": "email.securityAlert",
    "method": "POST",
    "mutation": true,
    "path": "/send-security-alert",
    "rust": "unsupported",
    "domainEvent": "user.security.alert"
  },
  {
    "auth": "session",
    "capability": "email",
    "embedded": "supported",
    "id": "email.signIn",
    "method": "POST",
    "mutation": true,
    "path": "/send-sign-in-email",
    "rust": "unsupported",
    "domainEvent": "user.sign-in.email"
  },
  {
    "auth": "public",
    "capability": "email",
    "embedded": "supported",
    "id": "user.email.verify.send",
    "method": "POST",
    "mutation": true,
    "path": "/send-verification-email",
    "rust": "supported"
  },
  {
    "auth": "public",
    "capability": "sessions",
    "embedded": "supported",
    "id": "session.bridge.exchange",
    "method": "POST",
    "mutation": true,
    "path": "/session/bridge/exchange",
    "rust": "unsupported"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "embedded": "supported",
    "id": "session.bridge.issue",
    "method": "POST",
    "mutation": true,
    "path": "/session/bridge/issue",
    "rust": "unsupported"
  },
  {
    "auth": "session",
    "capability": "password",
    "embedded": "supported",
    "id": "user.password.set",
    "method": "POST",
    "mutation": true,
    "path": "/set-password",
    "rust": "supported"
  },
  {
    "auth": "public",
    "capability": "password",
    "embedded": "supported",
    "id": "session.issue.email",
    "method": "POST",
    "mutation": true,
    "path": "/sign-in/email",
    "rust": "supported",
    "domainEvent": "session.issue"
  },
  {
    "auth": "public",
    "capability": "social",
    "embedded": "supported",
    "id": "session.issue.social",
    "method": "POST",
    "mutation": true,
    "path": "/sign-in/social",
    "rust": "supported",
    "domainEvent": "session.issue"
  },
  {
    "auth": "public",
    "capability": "password",
    "embedded": "supported",
    "id": "session.issue.username",
    "method": "POST",
    "mutation": true,
    "path": "/sign-in/username",
    "rust": "supported",
    "domainEvent": "session.issue"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "embedded": "supported",
    "id": "session.revoke.current",
    "method": "POST",
    "mutation": true,
    "path": "/sign-out",
    "rust": "supported",
    "domainEvent": "session.revoke"
  },
  {
    "auth": "public",
    "capability": "password",
    "embedded": "supported",
    "id": "user.create",
    "method": "POST",
    "mutation": true,
    "path": "/sign-up/email",
    "rust": "supported",
    "domainEvent": "user.create"
  },
  {
    "auth": "public",
    "capability": "jwt",
    "embedded": "supported",
    "id": "jwt.token",
    "method": "POST",
    "mutation": true,
    "path": "/token",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "twoFactor",
    "embedded": "supported",
    "id": "twoFactor.disable",
    "method": "POST",
    "mutation": true,
    "path": "/two-factor/disable",
    "rust": "supported",
    "domainEvent": "twoFactor.disable"
  },
  {
    "auth": "session",
    "capability": "twoFactor",
    "embedded": "supported",
    "id": "twoFactor.enable",
    "method": "POST",
    "mutation": true,
    "path": "/two-factor/enable",
    "rust": "supported",
    "domainEvent": "twoFactor.enable"
  },
  {
    "auth": "session",
    "capability": "twoFactor",
    "embedded": "supported",
    "id": "twoFactor.backupCodes.generate",
    "method": "POST",
    "mutation": true,
    "path": "/two-factor/generate-backup-codes",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "twoFactor",
    "embedded": "supported",
    "id": "twoFactor.getUri",
    "method": "POST",
    "mutation": false,
    "path": "/two-factor/get-totp-uri",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "twoFactor",
    "embedded": "supported",
    "id": "twoFactor.emailOtp.send",
    "method": "POST",
    "mutation": true,
    "path": "/two-factor/send-otp",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "twoFactor",
    "embedded": "supported",
    "id": "twoFactor.backupCodes.consume",
    "method": "POST",
    "mutation": true,
    "path": "/two-factor/verify-backup-code",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "twoFactor",
    "embedded": "supported",
    "id": "twoFactor.emailOtp.verify",
    "method": "POST",
    "mutation": true,
    "path": "/two-factor/verify-otp",
    "rust": "supported"
  },
  {
    "auth": "session",
    "capability": "twoFactor",
    "embedded": "supported",
    "id": "twoFactor.verifyEnable",
    "method": "POST",
    "mutation": true,
    "path": "/two-factor/verify-totp",
    "rust": "supported",
    "domainEvent": "twoFactor.enable"
  },
  {
    "auth": "session",
    "capability": "social",
    "embedded": "supported",
    "id": "account.unlink",
    "method": "POST",
    "mutation": true,
    "path": "/unlink-account",
    "rust": "supported",
    "domainEvent": "account.unlink"
  },
  {
    "auth": "session",
    "capability": "password",
    "embedded": "supported",
    "id": "user.update",
    "method": "POST",
    "mutation": true,
    "path": "/update-user",
    "rust": "supported",
    "domainEvent": "user.update"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "embedded": "supported",
    "id": "authorization.assignments.members.replace",
    "method": "PUT",
    "mutation": true,
    "path": "/authorization/assignments/members/{memberId}",
    "rust": "unsupported"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "embedded": "supported",
    "id": "authorization.assignments.users.replace",
    "method": "PUT",
    "mutation": true,
    "path": "/authorization/assignments/users/{userId}",
    "rust": "unsupported"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "embedded": "supported",
    "id": "authorization.roles.by.rights",
    "method": "PUT",
    "mutation": true,
    "path": "/authorization/roles/{id}/rights",
    "rust": "unsupported"
  }
];
